<div class="calendar-container">
  <p-calendar
    #calendar
    placeholder="Select Date"
    selectionMode="range"
    dateFormat="M d, yy"
    inputStyleClass="calendar"
    icon="albis-icons-calendar"
    (onShow)="setPopupState(true)"
    (onClose)="setPopupState(false)"
    (onSelect)="onSelect()"
    [appendTo]="'body'"
    [showButtonBar]="false"
    [readonlyInput]="true"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [numberOfMonths]="numberOfMonths"
    [showIcon]="true"
    [showOtherMonths]="true"
    [firstDayOfWeek]="1"
    [(ngModel)]="selectedLocalDates">
    <ng-template pTemplate="header"
      ><div class="header-container">
        <p-toggleButton
          [(ngModel)]="isLast24HoursSelected"
          (onChange)="selectPreset('Last 24 Hours')"
          offLabel="Last 24 Hours"
          onLabel="Last 24 Hours"
          [disabled]="isLast24HoursSelected">
        </p-toggleButton>
        <p-toggleButton
          [(ngModel)]="isLast7DaysSelected"
          (onChange)="selectPreset('Last 7 Days')"
          offLabel="Last 7 Days"
          onLabel="Last 7 Days"
          [disabled]="isLast7DaysSelected">
        </p-toggleButton>
        <p-toggleButton
          [(ngModel)]="isLast30DaysSelected"
          (onChange)="selectPreset('Last 30 Days')"
          offLabel="Last 30 Days"
          onLabel="Last 30 Days"
          [disabled]="isLast30DaysSelected">
        </p-toggleButton>
        <p-toggleButton
          [(ngModel)]="isThisMonthSelected"
          (onChange)="selectPreset('This Month')"
          offLabel="This Month"
          onLabel="This Month"
          [disabled]="isThisMonthSelected">
        </p-toggleButton>
        <p-toggleButton
          [(ngModel)]="isLastMonthSelected"
          (onChange)="selectPreset('Last Month')"
          offLabel="Last Month"
          onLabel="Last Month"
          [disabled]="isLastMonthSelected">
        </p-toggleButton>
      </div>
    </ng-template>
    <ng-template pTemplate="date" let-date>
      <span
        [ngStyle]="{
          backgroundColor: 'inherit',
          textDecoration: isDateOutOfRange(date) ? 'line-through' : 'inherit',
          color: isDateOutOfRange(date) ? 'rgba(0, 0, 0, 0.3)' : 'inherit',
        }"
        >{{ date.day }}</span
      >
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="footer-container">
        <span>Please choose a range within the selectable interval</span>
        <p-button label="Apply" (onClick)="onDateUpdate()"></p-button>
      </div>
    </ng-template>
  </p-calendar>
  <button *ngIf="showResetButton" class="reset-button" type="button" (click)="onResetClicked()">X</button>
</div>
